import {
  Button,
  ButtonRounded,
  EditableDescription,
  EditableTitle,
  EditableVideo,
  ScrollRef,
  WContainer,
  WImage,
} from '@components/atoms'
import { Play } from '@components/icons'
import { MenuItemType } from '@utils/types'
import { useState } from 'react'
import styles from './TextMedia.module.sass'

interface Props {
  item: MenuItemType
  refId?: string
  mediaPos?: 'left' | 'right'
  size?: 'lg' | 'sm'
  editMode?: boolean
  theme?: '' | 'neutral10' // quando è vuoto è bianco perchè eredita lo sfondo del body
  className?: string
}

const TextMedia = (props: Props) => {
  const {
    item = undefined,
    refId = undefined,
    mediaPos = 'left',
    editMode = false,
    theme = '',
    size = 'lg',
    className = '',
  } = props

  const [isPlaying, setIsPlaying] = useState(false)

  const startVideo = () => {
    setIsPlaying(true)
    if (item.video?.provider?.includes('youtube')) {
      const el = document.getElementById(`textmedia_videoiframe_${item.pk}`)
      if (el)
        el.contentWindow?.postMessage(JSON.stringify({ event: 'command', func: 'playVideo' }), '*')
    }
  }

  return item ? (
    <div
      className={`${styles.root} ${styles[`root--${size}`]} 
      ${styles[`root--${theme}`]} 
      ${item.spaceTop ? styles[`root--st-${item.spaceTop}`] : ''} 
      ${item.spaceBottom ? styles[`root--sb-${item.spaceBottom}`] : ''} 
      ${styles[`root--media-${mediaPos}`]}
      ${isPlaying ? styles[`root--playing`] : ''}
      ${item.video?.provider !== 'local' ? styles['root--videoIframe'] : ''}
      ${editMode ? styles['root--editMode'] : ''} ${className}`}
    >
      {!!refId && <ScrollRef id={refId} />}
      <WContainer variant={size === 'sm' ? 'sm' : undefined}>
        <div className={`${styles.layout}`}>
          <div className={styles.main}>
            {((!!item.intro && !!item.name) || !!item.description) && (
              <div className={styles.content}>
                <EditableTitle title={item.name} className={styles.title} editMode={editMode} />
                <EditableTitle
                  title={item.intro}
                  variant="h3"
                  className={styles.subtitle}
                  editMode={editMode}
                />
                <EditableDescription
                  description={item.description}
                  className={styles.description}
                  editMode={editMode}
                />
              </div>
            )}
            {(editMode ||
              (!!item.ctaLabel && !!item.url) ||
              !!item?.children?.filter((x) => !!x.ctaLabel && !!x.url)?.length) && (
              <div className={`${styles.ctaBox} ${styles['ctaBox--desktop']}`}>
                {!!item.ctaLabel && !!item.url && (
                  <Button
                    label={item.ctaLabel}
                    href={item.url}
                    newPage={item.blank}
                    icon={item.icon}
                    iconPos={item.iconPos}
                    variant={'ghost'}
                  />
                )}
                {editMode ? (
                  <>{item.children}</>
                ) : item?.children?.filter((x) => !!x.ctaLabel && !!x.url)?.length ? (
                  item?.children
                    ?.filter((x) => !!x.ctaLabel && !!x.url)
                    .map((x) => (
                      <Button
                        label={x.ctaLabel}
                        href={x.url}
                        newPage={x.blank}
                        icon={x.icon}
                        iconPos={x.iconPos}
                        variant={x.variant}
                      />
                    ))
                ) : (
                  <></>
                )}
              </div>
            )}
          </div>
          {(item.video?.provider === 'local' && item.video?.url) ||
          (item.video?.provider !== 'local' && item.video?.videoId) ? (
            <div className={`${styles.videoBox}`}>
              <EditableVideo
                iframeId={`textmedia_videoiframe_${item.pk}`}
                item={item.video}
                preserveRatio
                playControl={isPlaying}
                editMode={editMode}
                className={styles.video}
              />
              <WImage
                className={styles.videoPreview}
                src={item.image}
                alt={item?.imageAlt}
                maxHeight={728}
                maxWidth={612}
                objectFit="cover"
              />
              <ButtonRounded
                icon={<Play />}
                className={styles.playButton}
                onClick={() => startVideo()}
              />
            </div>
          ) : (
            <div className={`${styles.imageBox}`}>
              {!!item.image && (
                // Requisiti: min 728w, height auto
                <WImage
                  src={item.image}
                  maxWidth={728}
                  maxHeight={612}
                  alt={item?.imageAlt}
                  title={item?.imageAlt}
                />
              )}
            </div>
          )}
          {!editMode &&
            ((!!item.ctaLabel && !!item.url) ||
              !!item?.children?.filter((x) => !!x.ctaLabel && !!x.url)?.length) && (
              <div className={`${styles.ctaBox} ${styles['ctaBox--mobile']}`}>
                {!!item.ctaLabel && !!item.url && (
                  <Button
                    label={item.ctaLabel}
                    href={item.url}
                    newPage={item.blank}
                    icon={item.icon}
                    iconPos={item.iconPos}
                    variant={'ghost'}
                  />
                )}
                {editMode ? (
                  <>{item.children}</>
                ) : item?.children?.filter((x) => !!x.ctaLabel && !!x.url)?.length ? (
                  item?.children
                    ?.filter((x) => !!x.ctaLabel && !!x.url)
                    .map((x) => (
                      <Button
                        label={x.ctaLabel}
                        href={x.url}
                        newPage={x.blank}
                        icon={x.icon}
                        iconPos={x.iconPos}
                        variant={x.variant}
                      />
                    ))
                ) : (
                  <></>
                )}
              </div>
            )}
        </div>
      </WContainer>
    </div>
  ) : (
    <></>
  )
}

export default TextMedia
